module.exports = __webpack_public_path__ + "static/media/Maja.6ce1f812.jpeg";